import type { PieceKind } from "./types";

/** A freestanding grind rail from `a` to `b`, `y` high, or sloped down (or up) to `yb` at `b`: a handrail (#10). */
export interface RailPiece {
  kind: "rail";
  a: { x: number; z: number };
  b: { x: number; z: number };
  y: number;
  yb?: number;
}

export const RAIL_PIECE: PieceKind<RailPiece> = {
  fields: ["a", "b", "y", "yb"],
  placed: false,
  check(c, o, path, _bounds, reach) {
    // Out past a beach side as far as a placed piece, so a rail can stand on the pier (#233).
    for (const end of ["a", "b"]) {
      const p = c.obj(o[end], `${path}.${end}`);
      if (!p) continue;
      c.only(p, ["x", "z"], `${path}.${end}`);
      c.num(p, "x", `${path}.${end}`, reach.x);
      c.num(p, "z", `${path}.${end}`, reach.z);
    }
    c.num(o, "y", path, { min: 0.1, max: 10 });
    c.num(o, "yb", path, { min: 0.1, max: 10, optional: true });
  },
  compile(p, out) {
    out.rails.push({ a: { ...p.a }, b: { ...p.b }, y: p.y, ...(p.yb === undefined ? {} : { yb: p.yb }), kind: "rail" });
  },
};
